import { eKeHoachNamActionsObj } from "../../action-types/ke-hoach/IKeHoachNamActions";
import { generateActions } from "../generateActions";

export const keHoachNamActions = {
  ...generateActions(eKeHoachNamActionsObj, "KE_HOACH_NAM"),
};
